import React, { useState, useEffect, useRef } from 'react';
import '../App.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, FormGroup, Button, Input } from 'reactstrap';
import MyStorage from './util/storage'
import { Oval as Loader } from 'react-loader-spinner';
import moment from 'moment';
import { ToastContainer } from 'react-toastify';
import showToast from './util/toast';
import { db1, storage1 } from '../../firebase/firebase1';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import add from '../assets/add.png';
import cross from '../assets/delete.png';
import Resizer from 'react-image-file-resizer';
import compressVideo from './util/video-compress';
import Api from './api/api';
import firebase from "firebase/compat/app";

let i = 1
let imageUrls = []

const AddMedicalTidbit = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const model = location.state?.model
  const editMode = model != null

  const [title, setTitle] = useState(editMode ? model.title : '');

  const [loader, setLoader] = useState(false);
  const addVideoRef = useRef(null);
  const [video, setVideo] = useState(null);
  // null = not compressing, 0..100 = progress
  const [compressing, setCompressing] = useState(null);
  const addScreenshot = useRef(null);
  const [images, setImages] = useState([{}]);

  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const onEditorStateChange = (editorState) => {
    setEditorState(editorState)
  };

  useEffect(() => {
    if (editMode) {
      setTitle(model.title)
      if (model.body) {
        const contentBlock = htmlToDraft(model.body);
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        setEditorState(EditorState.createWithContent(contentState))
      }
      let imgs = [{}];
      if (model.thumbUrl) {
        imgs.push({
          file: null,
          url: model.thumbUrl,
          name: '',
        });
      }
      setImages(imgs);
      if (model.videoUrl) {
        setVideo({
          file: null,
          url: model.videoUrl,
          name: model.fileName || '',
          fileName: model.fileName || ''
        });
      }
    }
  }, [])

  if (!MyStorage.isLogin()) {
    navigate('/admin/login')
    return null
  }

  const addNewVideo = () => {
    if (compressing != null) {
      showToast('error', 'Video is still compressing!')
      return
    }
    if (video == null) {
      showToast('error', 'Choose Video!')
      return
    }
    if (images.length === 1) {
      showToast('error', 'Choose Thumbnail!')
      return
    }
    if (title === '') {
      showToast('error', 'Fill complete form!')
      return
    }

    let body = draftToHtml(convertToRaw(editorState.getCurrentContent()))
    if (body.length < 10) {
      showToast('error', 'Please enter body!')
      return
    }

    setLoader(true);
    uploader(title, body)
  };

  const editNewVideo = () => {
    if (title === '') {
      showToast('error', 'Fill complete form!')
      return
    }

    let body = draftToHtml(convertToRaw(editorState.getCurrentContent()))
    if (body.length < 10) {
      showToast('error', 'Please enter body!')
      return
    }

    setLoader(true);
    i = 1
    imageUrls = []
    updater()

    db1.collection('medical_tidbits')
      .doc(model.id)
      .set({
        title: title,
        body: body
      }, { merge: true })
      .then(() => {
        setLoader(false);
        showToast('success', 'Medical Tidbit Saved!')
        navigate(-1)
      })
      .catch(() => {
        showToast('error', 'Save Failed!');
      });
  };

  const uploader = (title_, body_) => {
    uploadFile(
      'medical_tidbits/' + video.name,
      video.file,
      (videoUrl) => {
        setVideo(null)
        uploadFile(
          'medical_tidbits/' + images[1].name,
          images[1].file,
          (thumbUrl) => {
            addVideoToFirebase(title_, body_, videoUrl, thumbUrl)
          }
        );
      }
    );
  };

  const addVideoToFirebase = (title, body, videoUrl, thumbUrl) => {
    let video_ = {
      title: title,
      body: body,
      videoUrl: videoUrl,
      fileName: video ? video.fileName : '',
      thumbUrl: thumbUrl,
      added_date: parseInt(moment() + '')
    };
    db1.collection('medical_tidbits')
      .add(video_)
      .then((doc) => {
        setLoader(false);
        showToast('success', 'Medical Tidbit Saved!')
        sendNotification(doc.id)
        navigate(-1)
      })
      .catch(() => {
        showToast('error', 'Save Failed!');
      });
  };

  const sendNotification = (docId) => {
    let notifTitle = 'New Medical Tidbit by Liviq'
    let notifBody = 'Check out the new medical tidbit by Liviq!'
    let obj = {
      title: notifTitle,
      body: notifBody,
      type: 'medical_tidbit',
      docId: docId,
      added_date: firebase.firestore.FieldValue.serverTimestamp()
    }
    db1.collection('notifications').add(obj)
    Api.sendPushToAll(notifTitle, notifBody, () => { }, () => { })
  };

  const updater = () => {
    if (images.length > 1) {
      if (images[1].file != null) {
        uploadFile(
          'medical_tidbits/' + images[1].name,
          images[1].file,
          (thumbUrl) => {
            db1.collection('medical_tidbits')
              .doc(model.id)
              .set({ thumbUrl: thumbUrl }, { merge: true })
          }
        );
      }
    }

    if (video != null) {
      if (video.file != null) {
        uploadFile(
          'medical_tidbits/' + video.name,
          video.file,
          (videoUrl) => {
            let fileName = video.fileName
            setVideo(null)
            db1.collection('medical_tidbits')
              .doc(model.id)
              .set({
                videoUrl: videoUrl,
                fileName: fileName
              }, { merge: true })
          }
        );
      }
    }
  };

  const uploadFile = (path, photo, onSuccess) => {
    const uploadTask = storage1.ref(path).put(photo);
    uploadTask.on('state_changed',
      () => { },
      (error) => {
        console.log(error);
      },
      () => {
        storage1.ref(path).getDownloadURL().then((url) => {
          onSuccess(url);
        })
      });
  };

  const handleAddVideo = async (event) => {
    const file = event.target.files[0];
    if (file == null) return;

    setCompressing(0);
    const compressed = await compressVideo(file, (percent) => setCompressing(percent));
    setCompressing(null);

    let url = URL.createObjectURL(compressed);
    setVideo({ file: compressed, url: url, name: compressed.name, fileName: compressed.name });
  };

  const resizeFile = (file) => new Promise(resolve => {
      Resizer.imageFileResizer(file, 1024, 1024, 'JPEG', 90, 0,
          uri => {
              resolve(uri);
          }, 'file');
  });

  const handleAddImage = async (event) => {
    let temp = [{}];
    for (let i = 0; i < event.target.files.length; i++) {
      const file = event.target.files[i];
      const resizedImage = await resizeFile(file);
      let url = URL.createObjectURL(resizedImage);
      temp = temp.concat({ file: resizedImage, url: url, name: resizedImage.name });
    }
    setImages(temp);
  };

  const showVideoSection = () => {
    return (
      <div style={{ marginRight: 10, marginBottom: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <div onClick={() => {
          addVideoRef.current.click();
        }} style={{ width: 100, height: 100, backgroundColor: 'gray', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
          <img src={add} style={{ width: 30, height: 30 }} alt="add" />
          <input
            type='file'
            accept='video/*'
            style={{ display: 'none' }}
            ref={addVideoRef}
            onChange={handleAddVideo}
          />
        </div>

        {compressing != null &&
          <div style={{ fontSize: 12, color: 'gray', alignSelf: 'center', marginTop: 5 }}>
            Compressing… {compressing}%
          </div>
        }

        {compressing == null && video != null &&
          <div style={{ fontSize: 12, color: 'blue', alignSelf: 'center', marginTop: 5 }}>
            {video.fileName}
          </div>
        }
      </div>
    );
  };

  const showProductImages = () => {
    return images.map((item, index) => {
      if (index === 0) {
        return (
          <div key={index} style={{ marginRight: 10, marginBottom: 10 }}>
            <div onClick={() => {
              addScreenshot.current.click();
            }} style={{ width: 100, height: 100, backgroundColor: 'gray', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
              <img src={add} style={{ width: 30, height: 30 }} alt="add" />
              <input
                type='file'
                accept='image/*'
                style={{ display: 'none' }}
                ref={addScreenshot}
                onChange={handleAddImage}
              />
            </div>
          </div>
        );
      }
      return (
        <div key={index} style={{ display: 'inline-flex', width: 100, height: 100, marginRight: 10, marginBottom: 10 }}>
          <img src={item.url} alt="thumbnail" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
          <div onClick={() => {
            const temp = images.filter((_, j) => index !== j);
            setImages(temp);
          }} style={{ width: 25, height: 25, marginLeft: -25, marginTop: 0, backgroundColor: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
            <img src={cross} style={{ width: 20, height: 20 }} alt="delete" />
          </div>
        </div>
      );
    });
  }

  return (
    <div className='main'>
      <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
        <div style={{ color: 'blue' }}>
          {editMode ? 'Edit Medical Tidbit' : 'Add Medical Tidbit'}
        </div>
      </div>

      <div
        style={{ width: '100%', display: 'flex', flexDirection: 'column', padding: 0 }}>
        <div style={{ paddingTop: 30, paddingBottom: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100vh', overflow: 'scroll' }}>
          <Form className='form' style={{ padding: 20, backgroundColor: 'white', borderRadius: 10, minWidth: 600 }}>

            <div style={{ marginBottom: 10, display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', justifyContent: 'center' }}>

              <FormGroup style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: 10 }}>
                <div>Choose Video:</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: 5 }}>
                  {showVideoSection()}
                </div>
              </FormGroup>

              <FormGroup style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: 10 }}>
                <div>Thumbnail:</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: 5 }}>
                  {showProductImages()}
                </div>
              </FormGroup>

              <FormGroup style={{ marginTop: 0, width: '100%' }}>
                <Input
                  style={{ fontSize: 18 }}
                  type='text'
                  placeholder='Enter Title'
                  value={title}
                  onChange={(event) => {
                    setTitle(event.target.value)
                  }} />
              </FormGroup>

              <FormGroup style={{ marginTop: 10, width: '100%' }}>
                <div>Description</div>
                <Editor
                  editorStyle={{ backgroundColor: '#fafafa', paddingLeft: 10, paddingRight: 10, height: 150 }}
                  editorState={editorState}
                  toolbarClassName="toolbarClassName"
                  wrapperClassName="wrapperClassName"
                  editorClassName="editorClassName"
                  onEditorStateChange={onEditorStateChange}
                />
              </FormGroup>

            </div>

            <Button
              className='btn-block btn-dark'
              style={{ marginTop: 15, fontSize: 16, width: '100%', backgroundColor: 'orange', borderWidth: 0, height: 50 }}
              onClick={() => {
                if (!editMode)
                  addNewVideo()
                else
                  editNewVideo()
              }}>
              Save Medical Tidbit
            </Button>

          </Form>
        </div>
      </div>

      {loader ?
        <div style={{ position: 'absolute', display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', height: '80%', width: '80%' }}>
          <div style={{ padding: 10, backgroundColor: 'red', borderRadius: 100 }}>
            <Loader
              color="white"
              height={70}
              width={70}
              visible={true} />
          </div>
        </div>
        :
        null
      }

      <div>
        <ToastContainer />
      </div>

    </div>
  );
}

export default AddMedicalTidbit;
